import {
  Menu as ChakraMenu,
  MenuButton,
  MenuList,
  MenuItem,
  Flex,
  Icon,
  Text
} from '@chakra-ui/react';
import React from 'react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { IoIosMenu } from 'react-icons/io';

export const Menu = ({ list, selected, onSelect }) => {
  //orderlist localeCompare
  const orderList = list?.sort((a, b) =>
    a.descricao_grupo_produto.localeCompare(b.descricao_grupo_produto)
  );
  return (
    <ChakraMenu>
      <MenuButton>
        <Flex
          display="flex"
          flexDirection="row"
          color="#414042"
          fontSize="14px"
          alignItems="center"
          gap="5px">
          <Icon as={IoIosMenu} fontSize="20px" color="#378BBF" />
          <Text>{selected || 'Todos os Brindes'}</Text>
          <Icon as={ChevronDownIcon} fontSize="20px" color="#378BBF" />
        </Flex>
      </MenuButton>
      <MenuList
        width="800px"
        display="flex"
        padding="10px"
        height="600px"
        flexDirection="column"
        flexWrap="wrap">
        {orderList?.map((item, index) => (
          <MenuItem
            key={item.descricao_grupo_produto}
            maxW="200px"
            fontSize="14px"
            onClick={() => onSelect(item)}>
            {item.descricao_grupo_produto}
          </MenuItem>
        ))}
      </MenuList>
    </ChakraMenu>
  );
};
